import {FC} from 'react'

import {TABLET_SCREENSIZE} from '@/utils/styles/breakpoints'

import {HeaderMainButtonProps} from '../HeaderMainButton'
import {HeaderLogo} from './HeaderLogo'
import {HeaderLogoWithCTA} from './HeaderLogoWithCTA'

type HeaderLogoResponsiveProps = {
  mainCtaButton?: HeaderMainButtonProps
}

export const HeaderLogoResponsive: FC<HeaderLogoResponsiveProps> = ({mainCtaButton}) => (
  <>
    {mainCtaButton ? (
      <>
        <div className="desktop">
          <HeaderLogo />
        </div>
        <div className="mobile">
          <HeaderLogoWithCTA mainCtaButton={mainCtaButton} />
        </div>
      </>
    ) : (
      <HeaderLogo />
    )}

    <style jsx>{`
      .mobile {
        display: none;
      }
      @media ${TABLET_SCREENSIZE} {
        .desktop {
          display: none;
        }
        .mobile {
          display: block;
        }
      }
    `}</style>
  </>
)
